import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Notice } from '../page/Notice';

/**
 * Board 1.4: the document's VAT number is not in the catalog. It offers to create the supplier with
 * what was read (the window opens filled) or to search another one.
 */
export function DocumentSupplierNotice({
  name,
  vat,
  onCreate,
  onSearch,
}: {
  readonly name: string;
  readonly vat: string;
  readonly onCreate: () => void;
  readonly onSearch: () => void;
}) {
  const { t } = useTranslation('suppliers');
  return (
    <Notice
      tone="info"
      icon={Sparkles}
      title={
        name.trim() === ''
          ? t('picker.document.notFoundNoName', { vat })
          : t('picker.document.notFound', { name: name.trim(), vat })
      }
      actions={
        <>
          <Button type="button" variant="outline" className="min-h-11" onClick={onCreate}>
            {t('picker.document.create')}
          </Button>
          <Button type="button" variant="ghost" className="min-h-11" onClick={onSearch}>
            {t('picker.document.searchOther')}
          </Button>
        </>
      }
    >
      <span>{t('picker.document.notFoundText')}</span>
    </Notice>
  );
}
